import { GalleryDto } from '@picflow/types';

export const sortSubGalleries = (galleries: GalleryDto[], sorting: string) => {
  sorting = sorting || 'created_at';
  const sortedGalleries = galleries.slice();
  sortedGalleries.sort((a, b) => (b[sorting] < a[sorting] ? 1 : -1));
  if (sorting === 'last_changed_at') sortedGalleries.reverse();
  return sortedGalleries;
};
